import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/content";

export default function SEO({ title, description, path = "/", type = "website", jsonLd }) {
  const url = `${SITE.domain}${path}`;
  const full = title ? `${title} | Amaya Pro` : "Amaya Pro — Network Lighting Control for Smarter Buildings";
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description || SITE.description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description || SITE.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description || SITE.description} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
